<template>
  <div class="row reverse-mobile justify-content-center">
    <AdminMenu></AdminMenu>

    <div class="col-12 col-md-9 center-content">
      <CommunityCard>
        <div >
          <PleaseWait
            v-if="isLoading"
            bg-colour="#ffffff"
            class="m-4 w-100 d-flex flex-column justify-content-center align-items-center small-full"
          />

          <div
            class="w-75 d-flex flex-column justify-content-center align-items-center small-full"
            v-if="!isLoading && reportedPosts.length == 0"
          >
            <NoResults></NoResults>
          </div>

          <div
            v-if="!isLoading && reportedPosts.length > 0"
            class="col-sm scenario-scroll-page"
          >
            <div class="row d-flex justify-content-center mr-4">
              <div
                v-if="!isLoading && reportedPosts.length > 0"
                class="results-count"
              >
                <b class="deep">({{ reportedPosts.length }})</b>
                Post{{ reportedPosts.length != 1 ? "s" : "" }} reported
              </div>
            </div>
            <div>
              <ul style="list-style-type: none; padding-left: 0px">
                <li
                  v-for="reportedPost in reportedPosts"
                  v-bind:key="reportedPost.post.id"
                  class="mb-3"
                >
                  <div class="card py-2">
                    <div class="post-row">
                      {{ reportedPost.post.title }}
                    </div>
                    <div class="post-row">
                      {{ reportedPost.post.text }}
                    </div>
                    <div class="post-row">
                      <div class="mb-2 action action-2">
                        <button
                          class="btn btn-primary w-100"
                          @click="
                            ignoreReportedPost(
                              reportedPost.post.id,
                              reportedPost.reportedBy.id
                            )
                          "
                        >
                          Ignore Report
                        </button>
                      </div>
                      <div class="mb-2 action action-2">
                        <button
                          class="btn btn-primary w-100"
                          @click="deleteReportedPost(reportedPost.post.id)"
                        >
                          Delete Post
                        </button>
                      </div>
                    </div>
                    <div class="post-row">
                      <div style="width: 120px">Posted by:</div>
                      <div style="flex: 1">
                        <UserCard
                          :user="reportedPost.post.creator"
                          :includeActions="true"
                        />
                      </div>
                    </div>
                    <div class="post-row">
                      <div style="width: 120px">Reported by:</div>
                      <div style="flex: 1">
                        <UserCard
                          :user="reportedPost.reportedBy"
                          :includeActions="true"
                        />
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </CommunityCard>
    </div>
  </div>
</template>

<script>
import AdminMenu from "@/components/AdminMenu";
import PleaseWait from "@/components/PleaseWait";
import NoResults from "@/components/NoResults";
import ForumGroupService from "@/services/forumgroup.service";
import UserCard from "@/components/UserCard";
import CommunityCard from "@/components/CommunityCard";
import logger from "@/utils/logger";

export default {
  name: "Reported",
  components: {
    CommunityCard,
    AdminMenu,
    PleaseWait,
    NoResults,
    UserCard,
  },
  data: function () {
    return {
      isLoading: true,
      reportedPosts: null,
    };
  },
  methods: {
    getReportedPosts() {
      this.isLoading = true;
      ForumGroupService.getReportedPosts()
        .then((data) => {
          this.reportedPosts = data;
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.message.includes("404")) {
            this.component404 = true;
          }
        });
    },

    ignoreReportedPost(postId, reporterId) {
      ForumGroupService.ignoreReportedPost(postId, reporterId).then(() => {
        logger.log("admin.reported_post.ignored", "Reported post ignored", { postId, reporterId });
        this.getReportedPosts();
      });
    },

    deleteReportedPost(postId) {
      ForumGroupService.deleteReportedPost(postId).then(() => {
        logger.log("admin.reported_post.deleted", "Reported post deleted", { postId });
        this.getReportedPosts();
      });
    },
  },
  mounted() {
    this.isLoading = true;
    this.getReportedPosts();
  },
};
</script>

<style>
.post-row {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: 10px;
  margin-left: 10px;
  gap: 20px 5px;
}
</style>
